import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { PsRoutes } from '../shared/routing/Routes';
import ContractorsScreen from './screens/ContractorsScreen';
import ContractorsAddScreen from './screens/ContractorsAddScreen';
import ContractorsEditScreen from './screens/ContractorsEditScreen';

export class ContractorRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if ( currentUser.isSuperAdmin() ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.CONTRACTORS} component={ContractorsScreen}/>
                    <Route exact path={PsRoutes.CONTRACTORS_ADD} component={ContractorsAddScreen}/>
                    <Route exact path={PsRoutes.CONTRACTORS_EDIT} component={ContractorsEditScreen}/>
                </React.Fragment>
            );
        }

        return null;
    }
}

ContractorRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/contractors/ContractorsRouting.jsx